{
  "version": 1,
  "asset_id": "b1ef48c0-90c5-4a72-9ec2-640d8b7f551d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b1ef48c0-90c5-4a72-9ec2-640d8b7f551d/sleeve-gastrectomy-v2-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b1ef48c0-90c5-4a72-9ec2-640d8b7f551d/sleeve-gastrectomy-v2-800.jpg",
  "original_filename": "sleeve-gastrectomy-v2-800.jpg",
  "size": 60447,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:06:56Z"
}
